// src/common/hooks/useEnvironmentDetect.ts
export const useEnvironmentDetect = (): { isTelegramMiniApp: boolean } => {
  if (typeof window === "undefined") {
    return { isTelegramMiniApp: false };
  }

  const isTelegramMiniApp = !!(
    window.Telegram?.WebApp?.initData &&
    window.Telegram.WebApp.initData.length > 0
  );

  return { isTelegramMiniApp };
};
